import React, { useState } from 'react';
import Loading from '../generalComponets/Loading';
import Functions from '../../api/Functions';

function UserInbox() {
  const [showProcess, setShowProcess] = useState(false);

  const migrateNotifications = async () => {
    try {
      setShowProcess(true);
      const results = await Functions.migrateNotifications();
      console.log('results', results);
      setShowProcess(false);
    } catch (e) {
      console.log(e.message);
      setShowProcess(false);
    }
  };

  return (
    <div className="container">
      <div className="title-section">User Inbox</div>
      {showProcess ? <Loading /> : <div />}
      <div className="row">
        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Migrate Notifications</p>
              </div>
              <div className="card-action">
                <button className="waves-effect waves-teal btn-flat action-link" onClick={migrateNotifications}>
                  Migrate
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserInbox;
